import { render, staticRenderFns } from "./NutrientList.vue?vue&type=template&id=a0e08b12&scoped=true"
import script from "./NutrientList.vue?vue&type=script&lang=js"
export * from "./NutrientList.vue?vue&type=script&lang=js"
import style0 from "./NutrientList.vue?vue&type=style&index=0&id=a0e08b12&prod&lang=scss&scoped=true"
import style1 from "./NutrientList.vue?vue&type=style&index=1&id=a0e08b12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0e08b12",
  null
  
)

export default component.exports